export default __webpack_public_path__ + "static/media/spinnerr.ec066962.gif";